import { TUserProfileInfo } from 'types/state';
import { M8UserProfile } from 'services/production/types';
import { PersonalInfoFormValues } from 'types/personalInfoTypes';
import { Org, OrgInfoFormValues } from 'types/orgInfoTypes';
import { normalizeM8CompanySize } from 'services/production/utils/normalizeM8CompanySize';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { Person } from 'types/personTypes';

export const normalizeM8UserProfile = (m8UserProfile: M8UserProfile) => ({
  toFullName(): string {
    return normalizeProfileLike({
      firstName: m8UserProfile.firstName || '',
      lastName: m8UserProfile.lastName || '',
      middleName: m8UserProfile.middleName || '',
    }).toFullName();
  },
  toUserProfileInfo(): TUserProfileInfo {
    return {
      company: m8UserProfile.organization || '',
      firstName: m8UserProfile.firstName || '',
      lastName: m8UserProfile.lastName || '',
      middleName: m8UserProfile.middleName || '',
      phone: m8UserProfile.phone || '',
      orgStaffCount: m8UserProfile.companySize
        ? normalizeM8CompanySize(m8UserProfile.companySize).toOrgStaffCount()
        : null,
      position: m8UserProfile.position || '',
      location: m8UserProfile.country || '',
      resident: !!m8UserProfile.resident,
    };
  },
  toPersonalInfoFormValues(): PersonalInfoFormValues {
    return {
      firstName: m8UserProfile.firstName || '',
      middleName: m8UserProfile.middleName || '',
      lastName: m8UserProfile.lastName || '',
      phone: m8UserProfile.phone || '',
      position: m8UserProfile.position || '',
      partnerCode: ['', '', '', ''], // TODO
    };
  },
  toOrgInfoFormValues(): OrgInfoFormValues {
    return {
      name: m8UserProfile.organization || '',
      location: m8UserProfile.country || '',
      staffCount:
        m8UserProfile.companySize &&
        normalizeM8CompanySize(m8UserProfile.companySize).toOrgStaffCount(),
    };
  },
  toOrg(): Org {
    return {
      name: m8UserProfile.organization || '',
      location: m8UserProfile.country || '',
      staffCount: m8UserProfile.companySize
        ? normalizeM8CompanySize(m8UserProfile.companySize).toOrgStaffCount()
        : 'small',
    };
  },
  toPerson(): Person {
    return {
      firstName: m8UserProfile.firstName || '',
      middleName: m8UserProfile.middleName || '',
      lastName: m8UserProfile.lastName || '',
      phone: m8UserProfile.phone || '',
    };
  },
});
